import React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { Button } from '~/components';
import { Link } from 'react-router-dom';
import { useUserContext } from '~/hooks';
import { useModalContext } from '~/hooks/providers/ModalProvider';
import InviteTeamMemberModal from '~/features/user/settings/InviteTeamMemberModal';

const MyCompany: React.FC = () => {
    const { loggedInUser } = useUserContext();
    const { openModal } = useModalContext();

    return (
        <div className="card">
            <Header as="h2">My Company</Header>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '12px 0 20px' }}>
                <img
                    src={loggedInUser?.company?.logoS3Url}
                    alt={loggedInUser?.company?.name}
                    style={{ width: 40, height: 40, objectFit: 'contain' }}
                />
                <Header as="h3" style={{ margin: '0px', fontSize: '16px' }}>{loggedInUser?.company?.name}</Header>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>


                <Button
                    outlined
                    secondary
                    size="small"
                    onClick={() => {
                        openModal(InviteTeamMemberModal);
                    }}>
                    <Icon name="plus" /> Invite team member
                </Button>

                <Button
                    as={Link}
                    size="small"
                    secondary
                    outlined
                    to="/settings/company"
                    style={{ justifyContent: 'center' }}
                >
                    <Icon name="setting" /> Company settings
                </Button>
            </div>

        </div>
    );
};

export default MyCompany;